import React from 'react';
import PropTypes from 'prop-types';
import Card from '../../shared/Card';
import ImageUpload from '../../shared/ImageUpload';
import ImagePreview from '../../shared/ImagePreview';
import { Col, Row } from 'reactstrap';
import ImageCompressor from 'compressorjs';


class TestImages extends React.Component {
  constructor(props) {
    super(props);
    this.onDrop = this.onDrop.bind(this);
    this.onClear = this.onClear.bind(this);
  }

  static get propTypes() {
    return {
      edit: PropTypes.bool,
      images: PropTypes.array,
      imageDeleted: PropTypes.bool,
      imageBase64: PropTypes.array,
      onLoad: PropTypes.func,
      onClear: PropTypes.func,
      showErrorWindow: PropTypes.func,
      maxImages: PropTypes.number
    }
  }

  compressImage(file) {
    return new Promise((resolve, reject) => {
      new ImageCompressor(file,{
          quality: 0.8,
          maxWidth: 1000,
          maxHeight: 1000,
          success: resolve,
          error: reject
      })
    });
  }

  onDrop(files, rejectedFiles = []) {
    const MAX_FILE_SIZE = 1024 * 1024; // bytes
    const rejectedFile = rejectedFiles[0];

    if (files.length > this.props.maxImages || rejectedFile) {
      this.props.showErrorWindow();
      return;
    }

    files.forEach(file => {
      if (file.size > MAX_FILE_SIZE) {
        this.compressImage(file)
          .then((compressImage) => {
            compressImage.preview = file.preview;
            this.props.onLoad([compressImage])});
      } else {
        this.props.onLoad([file]);
      }
    });
  }

  onClear(index) {
    this.props.onClear(index);
  }

  render() {
    const {
      edit,
      images,
      imageBase64,
    } = this.props;
    return (
      <Card header='Attachment Photos' >
        <Choose>
          <When condition={edit}>
            <ImageUpload
              base64={imageBase64}
              onDrop={this.onDrop}
              onClear={this.onClear}
              files={images}
              showIcon={false}
              isTestImages={true}
              maxSize={10*1024*1024}
            />
          </When>
          <Otherwise>
            <div className='text-center'>
              <Row>
                {imageBase64.map((base64, index) =>
                  <Col key={index}>
                    <ImagePreview
                      src={base64 ? `data:image/png;base64, ${base64}` : null}
                    />
                  </Col>)
                }
              </Row>
            </div>
          </Otherwise>
        </Choose>
      </Card>
    );
  }
}

export default TestImages;


// WEBPACK FOOTER //
// src/components/testDetails/TestImages/index.jsx